import React from 'react';
import './Skeleton.css';

export const Skeleton = ({ width, height, className = '', variant = 'rectangular' }) => {
  return (
    <div 
      className={`skeleton ${variant} ${className}`}
      style={{ width, height }}
    />
  );
};

export const SkeletonText = ({ lines = 1, width = '100%', className = '' }) => {
  return (
    <div className={`skeleton-text-wrapper ${className}`}>
      {[...Array(lines)].map((_, index) => (
        <div
          key={index}
          className="skeleton text"
          style={{ 
            width: index === lines - 1 ? '60%' : width,
          }}
        />
      ))}
    </div>
  );
};

export const SkeletonCard = ({ className = '' }) => {
  return (
    <div className={`skeleton-card ${className}`}>
      <Skeleton height="200px" />
      <div className="skeleton-card-content">
        <SkeletonText lines={2} />
      </div>
    </div>
  );
};

export const SkeletonTable = ({ rows = 5, columns = 4, className = '' }) => {
  return (
    <div className={`skeleton-table ${className}`}>
      <div className="skeleton-table-header">
        {[...Array(columns)].map((_, index) => (
          <Skeleton key={index} height="40px" className="skeleton-table-cell" />
        ))}
      </div>
      {[...Array(rows)].map((_, rowIndex) => (
        <div key={rowIndex} className="skeleton-table-row">
          {[...Array(columns)].map((_, colIndex) => (
            <Skeleton key={colIndex} height="48px" className="skeleton-table-cell" />
          ))}
        </div>
      ))}
    </div>
  );
};